module.exports = __webpack_public_path__ + "static/media/logo_desktop.06184af9.png";